import $windowConfig from '../WindowConfig.js'
import $search from '../WindowSearch'
import { axiosP, axiosG, Api } from './index.js'

export default {
  /**
   * 2.0.1.查询白名单过滤的任务方案及下级信息
   * * [rap](https://rap.eoms.phone580.com/workspace/myWorkspace.do?projectId=29#)
   * * 负责人：恒聪
   * * 成功返回：resp.success:true
   * * const taskList = _.get(resp, ['datas', 'taskList'], [])
   * * const task = _.get(taskList, [0])  // 要根据实际情况获取 task
   * * const task = taskList.find(o => '' + o.taskId === taskId)
   * * result = ActivityTools.taskResolver(task)
   * * result: { data.[success|code|msg] }
   * * const action = _.get(task, ['actionList', 0], {})
   * * const sku = _.get(action, ['actionObjectList', 0], {})
   * * task.taskResult === '1' // 已经参与此 task
   * * 失败返回：resp.success: false
   * * errorCode: '410015' 用户校验失败, 需要登录
   * * errorMsg: ''
   * * const { errorCode = '', errorMsg = '哎呀，太多人抢了，请稍后再来。' } = resp
   * * if (errorCode === '410015') { content: '登录失败，请退出重新登录' })
   * * if (errorCode === '400038') { content: `活动已结束啦！ 移步去看看别的活动吧~`,
   * * if (errorCode === '400037' || errorMsg.includes('未开始')) { content: '活动暂未开始哦！',
   * * else const msg = ActivityTools.querySchemeErrorMsg(errorCode) || errorMsg  content: msg
   * @param data {object} {schemeNo默认从 windowConfig取|authToken|userId}
   * @return {*|Promise<any>}
   */
  queryCheckWhiteTaskAll (data = {}) {
    const { clientId, authType } = $windowConfig
    const [isGetTime] = ['1']
    const { userId, authToken } = data
    const param = {
      authType,
      clientId,
      schemeNo: data.schemeNo || $windowConfig.schemeNo,
      userId,
      isGetTime,
      ext: JSON.stringify({
        myAuthToken: authToken
      })
    }
    return axiosP(Api.secKill + 'fmapi/api/action/query-check-white-task-all', param)
  },

  /**
   * 1.3.收集用户行为。 答题、抢购, 领取奖品，领取优惠券，立减金或者登记等操作
   * * [rap](https://rap.eoms.phone580.com/workspace/myWorkspace.do?projectId=29#258)
   * * 负责人：恒聪
   * * 成功返回 success: true
   * * const combi = _.get(resp, 'datas.rewardList[0].combiList[0]', {})
   * * const { combiName = '', rewardInfo = '', winParam = '1', rewardShowUrl = '', rewardUrl = '' } = combi
   * * combiName      奖品名称，有时也用不上
   * * winParam       为大转盘的角度
   * * rewardInfo     描述信息
   * * rewardShowUrl  中奖的奖品图片
   * * rewardUrl      奖品图片，跟上面不同
   * * 失败返回 success: false
   * * const { errorCode = '', errorMessage = '请求失败，请稍候重试' } = resp
   * * ActivityTools.collectActionErrMsg(errorCode)
   * * 失败返回  success: true，但 rewardList 为空！这也是一种失败，一般为配置错误
   * @param data {object} {authToken|userId|actionNo一般从 task 中找 action 找 actionNo}
   */
  collectUserAction (data = {}) {
    const { authToken, userId, actionNo } = data
    const { openId, bankNo, cyAuthToken, cyOpenId, } = $search
    const { clientId, authType } = $windowConfig

    const ext = {
      bocBankNo: bankNo, // 登记业务量
      myAuthToken: authToken,
      openId,
      cyAuthToken,
      cyOpenId,
      // cyUserId, 不需要这个参数 v2.3
      cyAuthType: authType
    }

    const param = {
      clientId,
      userId,
      authType,
      actionParams: {
        actionNo,
        // objectList: [{ aswNo, objectKey, objectValue }]
      },
      ext: JSON.stringify(ext)
    }

    return axiosP(Api.secKill + 'fmapi/api/action/collect-user-action', param)
  },

  /**
   * 1.61.查询用户的领奖记录V2（修改）
   * * [rap](https://rap.eoms.phone580.com/workspace/myWorkspace.do?projectId=29#432)
   * * 负责人：敏杰
   * * 成功返回：resp.[success: true, recordCount: number, datas]
   * * datas.forEach(o => o.detailList.forEach(oo => oo.[rdetailName/rewardShowUrl/state/createTimeStamp/creatTime/salePrice?/productName?] ))
   * * state: [0 待发货 1 发货成功 2 发货中， -1 发货失败，-2 作废，]
   * * 失败返回：resp.[success: false, errorCode, errorMsg]
   * @param data {object} userId/token/pageNo可选/pageSize可选
   * @returns {Promise<*>}
   */
 queryReceiveRecordNew (data = {}) {
    const { authType, clientId, schemeNo } = $windowConfig
    const { userId, token: myAuthToken, pageNo = '1', pageSize = '20' } = data
    const ext = JSON.stringify({ myAuthToken })
    const param = { authType, clientId, schemeNo, userId, pageNo, pageSize, ext }
    return axiosP(Api.secKill + 'fmapi/api/reward/query-user-receive-record-new', param)
  },

  /**
   * * 1.7.1奖品领取接口(校验用户)
   * * [rap](https://rap.eoms.phone580.com/workspace/myWorkspace.do?projectId=29#585)
   * * 负责人：敏杰
   * * 目前在这里用于：权益中心，我的券，领取，
   * * 或用于：答题、签到后，资格到手后，领奖，反正就是，用于，手动开奖、领奖的
   * * 何时启动此接口：award.canReceive && award.canReceiveTime >= award.dateEnd
   * * 成功返回：resp.[success: true, ]
   * * 失败返回：resp.[success: false, errorCode['410015'重新登录, '410029'已领取], errorMsg]
   * @param data {object} {userId/token/sendNo关键，从award中取/openId}
   * @returns {Promise}
   */
  userReceiveReward (data = {}) {
    const { authType = 'FZS' } = $windowConfig
    const { userId, token: myAuthToken, sendNo, openId = '' } = data

    const param = {
      authType,
      sendNo,
      userId,
      ext: JSON.stringify({
        myAuthToken,
      })
    }

    if (openId) {
      param.voucherParams = {
        voucherKey: 'openId',
        voucherValue: openId
      }
    }

    return axiosP(Api.secKill + 'fmapi/api/reward/user-receive-reward', param)
  },
}
